import { Dispatch, SetStateAction } from 'react'
import { useIntl } from 'react-intl'

import BaseModal from 'components/Modal/BaseModal'
import {
  DropzoneModalContainer,
  DropzoneModalTitle,
} from 'components/Modal/DropzoneModal/styles'
import { H2 } from 'components/Typography/Headings'
import ProfileDropZone from './ProfileDropZone'
import { profilesPageMessages } from 'features/profiles/messages'

interface ProfileUploadModalProps {
  isOpen: boolean
  handleClose: () => void
  setUploadedFilename: Dispatch<SetStateAction<string>>
  onSuccess: () => void
}

function ProfileUploadModal({
  isOpen,
  handleClose,
  setUploadedFilename,
  onSuccess,
}: ProfileUploadModalProps) {
  const { formatMessage } = useIntl()

  return (
    <BaseModal isOpen={isOpen} onRequestClose={handleClose}>
      <DropzoneModalContainer>
        <DropzoneModalTitle>
          <H2>{formatMessage(profilesPageMessages.uploadProfileModalTitle)}</H2>
        </DropzoneModalTitle>

        <ProfileDropZone
          setUploadedFilename={setUploadedFilename}
          onSuccess={onSuccess}
          handleClose={handleClose}
        />
      </DropzoneModalContainer>
    </BaseModal>
  )
}

export default ProfileUploadModal
